import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CouponInfoHeader: React.FC<{
  className?: string;
  badgeText: string;
  title: string;
  hideBadgeIcon?: boolean;
  'data-testid'?: string;
}> = ({
  className,
  badgeText,
  title,
  hideBadgeIcon,
  'data-testid': dataTestId = 'contentPopper',
}) => {
  return (
    <Wrapper className={className}>
      <Badge>
        {!hideBadgeIcon && <Icon asset={GenericIconName.Coupons} size="XS" />}
        <BadgeText
          size={hideBadgeIcon ? 'px14' : 'px10'}
          data-testid={`${dataTestId}-discountBadge`}
        >
          {badgeText}
        </BadgeText>
      </Badge>
      <Title data-testid={`${dataTestId}-title`}>{title}</Title>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  word-break: break-word;
`;

const Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 4px;
  padding: 1px 8px 3px 8px;
  background: ${COLORS.PrimaryCoupon};
  border-radius: 4px;
`;

const BadgeText = styled(Text)`
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: ${FONT_SIZES.px20};
  color: ${COLORS.White};
`;

const Title = styled(Text)`
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 26px;
  text-align: center;

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px18};
  `)}
`;
